export function getAssetUrl(url: string): string {
  return '/assets' + url;
}
